import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "animate.css";
import "@bsm/component/dist/main.css";
import "@bsm/component/dist/index.css";
import "@bsm/login/dist/main.css";
import "@bsm/login/dist/index.css";
import "@bsm/user-management/dist/main.css";
// import "@bsm/user-management/dist/index.css";
import "@bsm/notification/dist/main.css"
import "@bsm/invoice/dist/index.css"
import "@bsm/students/dist/main.css"
import "./index.css";

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
